import React from 'react';

import SelectionModal from './abstract/modal';

function renderCallList(callList) {
  return <>
    <strong>{callList.name}</strong>
  </>;
}

const CallListSelectionModal = props => (
  <SelectionModal
    itemLabel="Call List"
    queryKey="name_cont"
    renderItem={renderCallList}
    searchPath="/contacts/task_lists.json"
    searchPlaceholder="Search Lists"
    {...props}
  />
);

export default CallListSelectionModal;
